import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { SchoolYearService } from '../../../../../services/schoool-year/school-year.service';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { SchoolYear } from '../../../../../models/school-years/school-year';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { TranslationService } from '../../../../../services/translation/translation.service';
import { CurriculumService } from '../../../../../services/curricula/curriculum.service';
import { environment } from '../../../../../../../environments/environment';
import { AddStudentDto } from '../../../../../models/students/dto/AddStudentDto';

@Component({
    selector: 'fuse-school-schedule-school-year',
    templateUrl: './divisions-config-colors.component.html',
    styleUrls: ['./divisions-config-colors.component.scss'],
    animations: fuseAnimations
})
export class DivisionsConfigColorsComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    public shifts = [];
    public courseYears: any[];
    public contador = 0;
    public schoolYear: SchoolYear = new SchoolYear();
    public data: any;
    public prevColors: string[];

    constructor(private authenticationService: AuthenticationService,
                public dialog: MatDialog,
                private location: Location,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private schoolYearService: SchoolYearService,
                private route: ActivatedRoute,
                private courseYearService: CourseYearService,
                private fb: FormBuilder,
                private translationService: TranslationService,
                private sweetAlertService: SweetAlertService,
                private curriculumService: CurriculumService) {
    }

    ngOnInit(): void {
        this.blockUI.start('Cargando datos...');
        this.data = this.route.snapshot.data;
        this.contador = 0;
        this.loadData();
    }
    public loadData() {
        this.shifts = [];
        this.courseYears = [];
        this.schoolYear = new SchoolYear();
        Observable.combineLatest(
            this.shiftService.getAll(),
            this.courseYearService.getAll(),
            this.schoolYearService.getById(this.authenticationService.getAuthData().SchoolYear.Id),
        ).subscribe(([shifts, courseYears, schoolYear]) => {
            // filtrar turnos por usuario
            const authData = this.authenticationService.getAuthData();
            this.shifts = shifts.filter(e => authData.Shifts.find(s => s.Id === e.Id));
            this.courseYears = courseYears;
            this.courseYears.forEach(e => e.Divisions = []);
            if (schoolYear) {
                this.schoolYear = schoolYear;
            }
            const observables = [];
            this.shifts.forEach(e => {
                observables.push(this.divisionService.getAllWithShiftId(e.Id, this.authenticationService.getAuthData().SchoolYear.Id));
            });
            Observable.combineLatest(
                observables
            ).subscribe((divisionsByShift) => {
                this.groupDivision(divisionsByShift);
                this.colorChange();
                this.blockUI.stop();
            });
        });
    }

    ngOnDestroy(): void {
    }

    public groupDivision(divisionsByShift) {
        divisionsByShift.forEach(dbs => {
            const shift = this.shifts.find(s => dbs.shiftId === s.Id);
            shift.divisions = dbs.divisions;
        });
    }

    gotoDivisionSchedule(division){
        this.router.navigate(['pages/divisions-schedule/' + division.Id]);
    }

    imprimirTodo(shift, event) {
        window.open(environment.backendUri + 'report/divisionschedule/' + shift.Id + '/' + this.authenticationService.getAuthData().SchoolYear.Id, '_new');
        event.stopPropagation();
        event.preventDefault();
    }

    gotoDivisionTeachers(division) {
        this.router.navigate(['pages/management/subjectdivisionteacher/' + division.Id]);
    }

    colorChange() {
        const merged = [].concat.apply([], this.shifts.map(s => s.divisions));
        this.prevColors = merged.map(e => e.Color).filter(e => e).filter((e, i, s) => s.indexOf(e) === i);
        this.prevColors = [...this.prevColors];
    }

    save() {
        this.blockUI.start(this.translationService.savingChanges);
        const data = [];
        this.shifts.forEach(s => {
            const tmp = s.divisions.map(e => {
                return {'Id': e.Id, 'Color': e.Color};
            });
            data.push(...tmp);
        });

        this.divisionService.saveColorConfig(data).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.translationService.translate('LABELS.SUCCESS_REQUEST', '', (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/configurations/divisions-config-colors/divisions-config-colors.component.ts